<template>
  <div class="mapnav_w">
    <div class="div_1 fz20 bc_0983CC font_w_bold c_fff text_left">
      站点导航
    </div>
    <div id="districtArea" class="div_2"></div>


    <ImportJs  @loadComplete="chartsCompleteFn" :src="static_resource + '/js/echarts.js'" scriptKey="echarts"/>

  </div>
</template>

<script>
import request from "@/utils/request";
import { filterRepeat } from "@/utils";
import { mapGetters,mapMutations } from "vuex";

import ImportJs from '@/components/base/ImportJs.vue'
export default {
  components: {
    ImportJs
  },
  data() {
    return {
      geodata: null, //区域geo数据
      myChart: null, //echart实例
      adcodeLevelHistory: [], // 预览地区编码记录
      currAreaProp: null, //当前区域属性

      chartCenter: [], //中心点

      adcode: null, //地区行政code
    };
  },
  created() {},
  mounted() {
    if(this.isEchartsComplete){
      this.initEchart();
    }
  },
  computed: {
    ...mapGetters(["siteInfo", "isPro",'isEchartsComplete','static_resource']),
    randomRgb() {
      return function () {
        return (
          "rgb(" +
          Math.floor(Math.random() * 130 + 110) +
          "," +
          Math.floor(Math.random() * 130 + 110) +
          "," +
          Math.floor(Math.random() * 130 + 110) +
          ")"
        );
      };
    },
  },
  watch:{
    isEchartsComplete:{
      handler(n){
        if(n){
          this.initEchart()
        }
      },
      immediate:true
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.initAreaMap(n.locId);
        }
      },
      immediate:true,
      deep:true,
    }
  },
  methods: {
    ...mapMutations({
      chartsCompleteFn:'app/chartsCompleteFn'
    }),

    //初始echart
    initEchart(e) {

      this.myChart = echarts.init(document.getElementById("districtArea"));

      // this.onEchartGetZr(); // 注册点击空白处事件
      // this.onEchartAreaClick(); // 注册点击图表事件
    },

    //初始区域地图
    async initAreaMap(adcode) {
      await this.getAreaGeoJson(adcode);
      this.drawAreaMap();
    },

    // 绘制区域
    drawAreaMap() {
      echarts.registerMap("某市", this.geodata, {});

      let options = {
        geo: {
          map: "某市",
          center: this.chartCenter,
          roam: true, //开启缩放，拉扯
          label: {
            show: true,
          },

          //区块设置
          regions: this.geodata.features.map((i) => {
            return {
              name: i.properties.name,
              itemStyle: {
                areaColor: this.randomRgb(),
              },
            };
          }),
        },
      };

      this.myChart.setOption(options);

    },

    // 获取区域geojson api
    async getAreaGeoJson(adcode) {
      this.adcode = adcode;

      //如果少于6位
      if (String(this.adcode).length < 6) {
        this.adcode = Number(adcode)
          .toFixed(6 - String(this.adcode).length)
          .replace(".", "");
      }

      let { data } = await request({
        url: `/user/outer/geo?code=${Number(this.adcode)}_full`,
      });
      this.geodata = data;

      if (data === null) {
        let { data } = await request({
          url: `/user/outer/geo?code=${Number(this.adcode)}`,
        });
        this.geodata = data;
      }

      if (!this.chartCenter.length) {
        this.setChartCenter(this.geodata.features[0].properties.center);
      }
    },

    //点击地区时 click
    onEchartAreaClick() {
      this.myChart.on("click", (e) => {
        this.currAreaProp = this.geodata.features.find(
          (i) => i.properties.name === e.name
        ).properties; //当前点击地区的属性

        if (!this.currAreaProp) return;

        this.setChartCenter(this.currAreaProp.center);

        this.recordAdcodeHistory(this.currAreaProp.parent.adcode);

        this.initAreaMap(this.currAreaProp.adcode);
      });
    },

    //点击空白时 click
    onEchartGetZr() {
      this.myChart.getZr().on("click", (event) => {
        // 没有 target 意味着鼠标/指针不在任何一个图形元素上，它是从“空白处”触发的。
        if (!event.target) {
          if (!this.currAreaProp || this.adcodeLevelHistory.length <= 1) return;

          this.currAreaProp.childrenNum = 1; //防止childrenNum等于0时，获取不是full完整的区域信息

          this.initAreaMap(this.adcodeLevelHistory.pop());
        }
      });
    },
    //设置图表center中心点
    setChartCenter(center) {
      this.chartCenter = center;
    },
    //记录预览过的地区编码
    recordAdcodeHistory(currAdcode) {
      this.adcodeLevelHistory.push(currAdcode);
      this.adcodeLevelHistory = filterRepeat(this.adcodeLevelHistory); //去重
    },
  },
};
</script>

<style lang="scss" scoped>
.mapnav_w {
  width: 295px;
  .div_1 {
    padding: 12px ;
  }
  .div_2 {
    width: 295px;
    height: 282px;
    background-color: #fff;
  }
}
</style>
